import React from "react";
import Skill from "./Skill";
import { FiExternalLink } from "react-icons/fi";
import { motion } from "framer-motion";
import Logo from "../assets/logo.svg";

const ProjectCard = ({ header, title, type, paragraph, skills, button, link, img, dir, seeMore }) => {
  return (
    <>
       {header && (
        <div className="flex flex-col gap-4 items-center">
          <div className="flex flex-col gap-2 items-center">
            <img src={Logo} alt="Logo" width={"24px"} />
            <h2 className="text-2xl md:text-4xl font-semibold">Projects</h2>
          </div>
          <p className="text-sm md:text-xl">Front-end - UI/UX - Logo design</p>
        </div>
      )}
      <motion.div
className={`flex flex-col md:flex-row ${
            dir === "ltr" ? "md:flex-row-reverse" : "md:flex-row"
          }
            group justify-between bg-[#0F0D11] min-w-[80%] md:max-w-[80%] ${ header ? "h-[70vh] mt-0": "h-[80vh]" } md:h-[45%] mt-6 md:mt-0 md:min-h-[55%]`}
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ amount: 0.3 }}
        transition={{ duration: 0.6, ease: "easeInOut" }}
      >
        {/* صورة المشروع */}
        <div
          className={`relative w-full md:w-[60%] rounded-t-lg  overflow-hidden h-full ${
            dir === "ltr" ? "md:rounded-r-lg" : "md:rounded-l-lg"
          }`}
        >
          <div className="absolute bg-gray_100 bg-opacity-30 group-hover:bg-opacity-0 w-full h-full transition-all delay-100"></div>
          <img
            src={img}
            alt={title}
            width="100%"
            height="100%"
            className="size-full object-cover"
          />
        </div>

        {/* تفاصيل المشروع */}
        <div className={`flex flex-col justify-between ${
            dir === "ltr" ? "items-start" : "items-end"
          } w-full md:w-[40%] rounded-l-lg py-6 px-4 md:px-8`}>
          <div className="flex flex-col gap-8 w-full">
            {/* عنوان المشروع والوصف */}
            <div>
              <div className="flex justify-between text-left mb-4 w-full">
                <h4 className="text-xl md:text-2xl font-semibold">{title}</h4>
                <span className="text-sm text-primary opacity-80">{type}</span>
              </div>
              <p className="text-left text-lg">{paragraph}</p>
            </div>

            {/* المهارات */}
            <div className="flex flex-wrap gap-6">
              {skills?.map((skill, index) => (
                <Skill key={index} title={skill} />
              ))}
            </div>
          </div>

          {/* الزر */}
          <div className="w-ful md:w-fit">
            {button && link && (
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex justify-center items-center w-full md:w-fit gap-2 py-4 px-6 mt-8 md:mt-0 bg-primary_800 group-hover:bg-primary_700 transition-all delay-100 rounded-lg text-xl font-semibold"
              >
                {button}
                <FiExternalLink />
              </a>
            )}
          </div>
        </div>
      </motion.div>

      {seeMore && (
        <button className="border-2 border-primary_700 text-primary_700 hover:bg-primary_800 font-medium hover:text-white_50 transition-all delay-100 py-2 px-4 rounded-md mt-6">
          See more projects
        </button>
      )}
    </>
  );
};

export default ProjectCard;
